export const missingProductImageUrl = '/Assets/Images/missing-image-product.png';
export const missingProductImageDarkUrl = '/Assets/Images/missing-image-product-dark.png';
export const missingProductImageDarkId26Url = '/Assets/Images/missing-image-product-dark-id26.png';
